<template>
  <b-row class="dyk-container">
    <b-col sm="12">
      <h3>{{ $t('didYouKnow') }}</h3>
    </b-col>
    <b-col sm="12">
      <p>
        {{ $t('didYouKnowContent') }}
        <a href="#">
          <b>{{ $t('learnMore') }}</b>
        </a>
      </p>
    </b-col>
  </b-row>
</template>

<script>
  export default { name: 'DidYouKnow' }
</script>


<style lang="scss">
  @import '../styles/variables.scss';

  .dyk-container {
    background-color: $primary;
    padding: 20px 0;
    color: $white;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  a,
  a:hover {
    color: inherit;
    text-decoration: underline;
  }
</style>




// WEBPACK FOOTER //
// src/components/DidYouKnow.vue